import React from "react";
import { withAppState, getAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { Loading, withFocusable, ModalSettings } from "../../services/visualLibraryService";
import {
  LayoutWrapperStyled,
  PlayerWrapperStyled,
  EPGWrapperStyled,
  CategoriesWrapperStyled,
  VideoMetaDataWrapperStyled,
  VideoWrapperStyled,
  CategoriesWrapperHeadingStyled,
  TimeTextStyled,
  EpgViews,
  LayoutEmptyStyled,
  GridLoadingWrapper,
  ExitModel,
  GlobalStyle
} from "./styles/Styled";
import { LivePlayerShade, Wrapper, LivePlayerShadeMeta } from "./livePlayerStyles/styled";
import EpgCategories from "../../components/EPG/EpgCategories/EpgCategories";
import EpgTooltip from "../../components/EPG/EpgTooltip";
import VideoMetaData from "../../components/EPG/VideoMetaData/VideoMetaData";
import { Text } from "../../services/visualLibraryService";
import { i18n, directions } from "../../services/i18nService";
import LivePlayer from "./LivePlayer";
import { config } from "../../config/config";
import StaticEpgView from "./StaticEpgView";
import { getSdk } from "../../services/sdkService";
import { DPLAY } from "../../utils/epgUtil";
import DefaultChannelImage from "../../components/EPG/PlayerPlaceholder/epgdefaultchannelimage1.png";
import DefaultChannelImageLeft from "../../components/EPG/PlayerPlaceholder/epgdefaultchannelimageleft.png";
import DynamicEpgView from "./DynamicEpgView";
import {
  getEpgCategories,
  getEpgEvents,
  firstPlaybackChannelEventsService,
  addToFavorite,
  removeFromFavorite,
  getUserFavoriteEpgChannels,
  EPG_API_CHANNEL_LIMIT
} from "../../services/avodFullExpService";
import { getUnixTime, getEpgTime } from "../../utils/timeStamp";
import { isSuitableFor4KPlayback, has4KProgramId } from "../../services/titleDataService";
import {
  getCurrentDate,
  getVideoMetaData,
  EPG_VIEWS,
  reduceDataForStaticView,
  EVENT_STATUS,
  getEpgCategoriesSlugsString,
  setCacheKeyForCategories,
  TAG_STATUS,
  CHANNEL_PLAN,
  isToGetLatestCategoryData
} from "../../utils/epgUtil";
import { isChampionsTrophyAddOn, isUserSubscribedToChannel } from "../../utils/subscriptionUtils";
import { getMultiTaggedAddOnContent } from "../../utils/addOnsUtil";
import PlayerPlaceholder from "../../components/EPG/PlayerPlaceholder/PlayerPlaceholder";
import { defaultFocusPath as headerFocusPath } from "../../components/Header";
import {
  getStatusTagText,
  calculateDurationForSlots,
  CHANNEL_TYPES,
  getTagsList,
  EPG_MODAL_TYPES,
  WIDEVINE_FORMATS
} from "../../utils/epgUtil";
import { getTagsListComponent } from "../../components/EPG/VideoMetaData/VideoMetaData";
import { getGlobalButtonInfo } from "../../errors/globalButtons";
import { getBuyBrandsInfoObj } from "../../utils/tvodUtils.js";
import {
  showSubscriptionModal,
  getSubscriptionNameForModal,
  getInActiveSubscriptionDisplayName
} from "../../utils/subscriptionUtils";
import { showContentNotAccessibleModal, showSignupPremiumPrompt } from "../../services/modalsService";
import { getNavigationReferences } from "../../services/navigationService";
import { removeFromMediaListFromEPG, addToMediaListFromEPG, getUserMyList } from "../../services/mediaListService";
import { getCookieByName } from "../../utils/commonUtils";
import { ButtonStyled } from "../../components/ModalSettings/styles/Styled";
import { isSupportedDeviceForMobileLite } from "../../utils/mobileLiteUtils";
import { isLoggedInUser } from "../../services/authenticationService";
import { getCurrentProfile } from "../../services/multipleProfilesService.js";
import { isHidePromptForKidsProfile } from "../../utils/promptUtils";
import { parseUrlParams } from "../../helpers/find.js";
import { RTL } from "../../e2e/utils/constants.js";
import { STARZ } from "../../utils/mediaDataRetrieval.js";

export const epgGridName = "epg";
const all = "all";
const MAIN_MENU = "mainMenu";
const PREFIX_CATEGORY = "secondaryItem";
const firstCategoryIndexFocus = "secondaryItem_0";
const TIME_TO_MILLISECONDS = 1000;
const HOURS_IN_A_DAY = 24;
const EPG_TOOLTIP_SHOW_FIRST_TIME = 6000; // 6 SEC
const EPG_TOOLTIP_HIDE_TIME = 6000; // 6 SEC
const ACTIVE = "active";
const IDLE = "idle";
//let signupInactivePromptTimer = null;
let isAnyModalOpen = false;
let isNewFavoriteAdded = false;
const ButtonModalFocus = withFocusable(ButtonStyled);

class Live extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      epgCurrentViewIndex: 0,
      categories: [],
      epgData: [],
      wholeEpgData: [],
      loading: false,
      currentVideoMetaData: null,
      previousVideoMetaData: null,
      currentCategory: all,
      videoData: null,
      isShowTooltip: false,
      isGridLoading: false,
      isUpComingLinear: false,
      isFullScreen: false,
      playFromResume: 0,
      onFullScreen: false,
      playerButtonEnter: null,
      addToMyListData: [],
      favoriteChannelList: [],
      isExiting: false,
      isError: false,
      errorHeading: "",
      errorMessage: "",
      refreshTime: null,
      wheelState: "idle",
      brandInfo: null,
      showQRCodeModal: false
    };
    this.navigation = this.navigation.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onUpdateWheelState = this.onUpdateWheelState.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.epgViews = [EPG_VIEWS.static, EPG_VIEWS.dynamic];
    this.epgStartTime = null;
    this.epgEndTime = null;
    this.indexes = {};
    this.changeViewRowIndex = 0;
    this.changeView = false;
    this.visibleRows = null;
    this.visibleCat = null;
    this.currentRowIndex = 0;
    this.categoryIndex = 0;
    this.clearRefreshTimeout = null;
    this.onBack = this.onBack.bind(this);
    this.updateVideoMetaData = this.updateVideoMetaData.bind(this);
    this.setInactiveSubscriptionForFirstChannel = this.setInactiveSubscriptionForFirstChannel.bind(this);
    this.playFromEPG = this.playFromEPG.bind(this);
    this.getEpgRefreshEvent = this.getEpgRefreshEvent.bind(this);
    this.showProgramMoreDetailsPopup = this.showProgramMoreDetailsPopup.bind(this);
    this.hideEpgModal = this.hideEpgModal.bind(this);
    this.promptRef = React.createRef();
    this.favoriteChannelHandler = this.favoriteChannelHandler.bind(this);
    this.defaultChannelAutoPlay = false;
    this.categoryFromCacheObj = null;
    this.isAllCategoryNeedLatestData = false;
    this.leftOffset = 0;
    this.rightOffset = 0;
    this.isEpgRefresh = false;
    this.signupInactivePromptTimer = null;
    this.kidsProfileModalOpen = false;
    this.toggleQRCodeModal = this.toggleQRCodeModal.bind(this);
    this.adCountry = getAppState().country.toUpperCase();
    this.appFlow = i18n.getDirection();
  }

  async componentDidMount() {
    const { onRef, history } = this.props;
    onRef && onRef(this);

    // --- Extract category parameter from URL ---
    const search = (history && history.location && history.location.search) || window.location.search;
    const params = parseUrlParams(search);
    const categoryParam = params["category"];
    const brndInfo = getBuyBrandsInfoObj(addons, subName);
    this.setState({
      brandInfo: {
        btnName: brndInfo?.buttonDisplayName,
        planName: brndInfo?.paymentPlanName,
        subscriptionDisplayName: brndInfo?.subscriptionDisplayName
      }
    });
    // --- Load page data with optional category parameter ---
    const loadResult = await this.loadLivePageDataWithCategory(categoryParam);

    if (!loadResult?.success) {
      return; // Exit early if loading failed
    }

    // --- Handle user authentication and signup prompt ---
    const userLogged = await this.getUserLoggedStatus();
    const isLoggedIn = await isLoggedInUser();

    const isHidePromptForkids = await isHidePromptForKidsProfile();
    if (getAppState()?.signupPromptActive && !userLogged && !isLoggedIn && !isHidePromptForkids) {
      this.startSignupInactivePromptTimer();
    }
    // show "switchto"
    const {
      applicationState: { addons }
    } = this.props;
    let subName = getSubscriptionNameForModal.call(this, this.state.defaultChannel);
    if (this.props.applicationState.currentFocus === headerFocusPath) {
      this.props.setFocus(`${PREFIX_CATEGORY}_${this.props.applicationState.selectedEpgCategoryIndex}`);
    }
  }

  async selectCategoryFromQueryParam(categoryParam) {
    const { categories, wholeEpgData } = this.state;

    // Find the category that matches the query parameter
    const matchingCategory = categories.find(
      category =>
        category.slug === categoryParam ||
        category.key === categoryParam ||
        category.label.toLowerCase() === categoryParam.toLowerCase()
    );

    if (matchingCategory) {
      // Set the category value (slug or comma-separated slugs for "all")
      const categoryValue = matchingCategory.value || matchingCategory.slug;
      const isAllCategory = categoryValue.split(",").length > 1;
      const isGetLatestData = isToGetLatestCategoryData(wholeEpgData, categoryValue, isAllCategory);

      try {
        // Load default channel if it's "all" category
        let defaultChannelResponse = isAllCategory
          ? await this.getDefaultChannelEpg(this.epgStartTime, this.epgEndTime, true)
          : null;

        // Load EPG events for the selected category
        let epgEvents = await getEpgEvents({
          category: categoryValue,
          ts_start: this.epgStartTime,
          ts_end: this.epgEndTime,
          profileType: getAppState()?.currentProfileType,
          xgeoCountry: getAppState()?.country.toUpperCase(),
          page: 1,
          limit: EPG_API_CHANNEL_LIMIT,
          avoidCache: isGetLatestData
        });

        // Embed user data
        epgEvents = epgEvents && (await this.embedUserDataToEpg(epgEvents));
        defaultChannelResponse = defaultChannelResponse && (await this.embedUserDataToEpg(defaultChannelResponse));

        // Get EPG data according to categories
        let epgDataAccordingToCategories = this.getEpgDataAccordingToCategories(categories, epgEvents);

        // Add default channel if available
        if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
          const defaultChannel = defaultChannelResponse.data[0];
          defaultChannel &&
            epgDataAccordingToCategories.unshift(this.embedDefaultChannelDataToEpg(defaultChannel, categories));
        }

        // Update refresh events
        this.getEpgRefreshEvent(epgEvents, defaultChannelResponse);

        // Update state with the new category data
        this.setState(
          {
            epgData: epgDataAccordingToCategories,
            currentCategory: categoryValue
          },
          () => {
            // Directly manipulate DOM to set selected class on the correct category
            setTimeout(() => {
              this.setCategorySelectionFromParams(categoryParam);
            }, 200);
          }
        );

        // Update the selected category index in the application state
        const categoryIndex = categories.findIndex(cat => cat.slug === matchingCategory.slug);
        if (categoryIndex !== -1) {
          this.props.stateActions.setSelectedEpgCategoryIndex(categoryIndex);
          // Reset indexes for the new category
          this.changeViewRowIndex = 0;
          this.currentRowIndex = 0;
          this.categoryIndex = categoryIndex;
          this.indexes.categoryIndex = categoryIndex;
        }

        // Update video metadata and play
        this.updateVideoMetaData(epgDataAccordingToCategories);
        this.playFromEPG(epgDataAccordingToCategories);
      } catch (error) {
        // Fall back to default behavior if there's an error
      }
    } else {
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { isExiting, isFullScreen, currentVideoMetaData, isError } = this.state;
    isExiting && !prevState.isExiting && this.confirmModalFocusPath && this.confirmModalFocusPath.props.setFocus();
    if (this.state.epgData.length > 0 && this.state.wheelState === "idle") {
      try {
        await this.getLiveIndex();
      } catch (e) {}
    }

    if (
      getAppState()?.globalModal === null &&
      (this.props.applicationState.currentFocus === "epgModalWatchLiveChannelFocusPath_passThru" ||
        this.props.applicationState.currentFocus === "epgModalWatchFromStartFocusPath_passThru" ||
        this.props.applicationState.currentFocus === "epgModalChannelDetailsFocusPath_passThru" ||
        this.props.applicationState.currentFocus === "epgModalFavoriteChannelFocusPath_passThru") &&
      !this.state.isExiting
    ) {
      this.props.setFocus(epgGridName);
      this.props.stateActions.setLastFocusedName(epgGridName);
      this.props.pauseNavigation();
    }

    /* specific to LG TV auto full screen mode */
    if (this.isEpgRefresh) {
      // do nothing
    } else {
      clearTimeout(this.refreshFullScreenTimeOut);
      if (
        !isFullScreen &&
        currentVideoMetaData &&
        !currentVideoMetaData.isThisDeviceSupported &&
        currentVideoMetaData.isUserSubscribedToChannel &&
        !isError
      ) {
        this.refreshFullScreenTimeOut = setTimeout(() => {
          this.setState({ isFullScreen: true });
        }, 900000); // 15 minutes
      }
    }
  }

  async loadLivePageData() {
    document.addEventListener("keydown", this.navigation, false);
    this.resetIndexState();
    this.epgStartTime = getUnixTime(getEpgTime(-6)); // from pervious 6 hrs
    this.epgEndTime = getUnixTime(getEpgTime(9)); // to next 9 hrs

    try {
      this.setState({ loading: true });
      let defaultChannelResponse = await this.getDefaultChannelEpg(this.epgStartTime, this.epgEndTime, true);
      let categoriesConfigs = await getEpgCategories({
        profileType: getAppState()?.currentProfileType,
        xgeoCountry: getAppState()?.country.toUpperCase(),
        avoidCache: true
      });
      const categoriesCommaSepList = getEpgCategoriesSlugsString(categoriesConfigs.data);
      this.categoryFromCacheObj = setCacheKeyForCategories(categoriesConfigs.data);
      let epgEvents = await getEpgEvents({
        category: categoriesCommaSepList,
        ts_start: this.epgStartTime,
        ts_end: this.epgEndTime,
        profileType: getAppState()?.currentProfileType,
        xgeoCountry: getAppState()?.country.toUpperCase(),
        avoidCache: true,
        page: 1,
        limit: EPG_API_CHANNEL_LIMIT
      });

      epgEvents = epgEvents && (await this.embedUserDataToEpg(epgEvents));
      defaultChannelResponse = defaultChannelResponse && (await this.embedUserDataToEpg(defaultChannelResponse));
      let epgDataAccordingToCategories = this.getEpgDataAccordingToCategories(categoriesConfigs.data, epgEvents);
      if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
        const defaultChannel = defaultChannelResponse.data[0];
        this.setState({
          defaultChannel: defaultChannel
        });
        defaultChannel &&
          epgDataAccordingToCategories.unshift(
            this.embedDefaultChannelDataToEpg(defaultChannel, categoriesConfigs.data)
          );
        this.defaultChannelAutoPlay = true;
      }
      if (epgDataAccordingToCategories.length !== 0) {
        const _addToMyListData = await this.getMediaListForEPG();
        const _favoriteChannelList = await this.getFavoriteListForEPG();
        this.props.setFocus(epgGridName);
        this.props.stateActions.setLastFocusedName(epgGridName);
        this.props.pauseNavigation();
        this.setInactiveSubscriptionForFirstChannel(epgDataAccordingToCategories);
        this.setState({
          categories: this.extendEpgCategories(categoriesConfigs, categoriesCommaSepList),
          epgData: epgDataAccordingToCategories,
          wholeEpgData: epgDataAccordingToCategories,
          loading: false,
          addToMyListData: _addToMyListData,
          favoriteChannelList: _favoriteChannelList,
          currentCategory: categoriesCommaSepList
        });
        this.updateVideoMetaData(epgDataAccordingToCategories);
        this.playFromEPG(epgDataAccordingToCategories);
        // this.clearRefreshTimeout && clearTimeout(this.clearRefreshTimeout);
        this.getEpgRefreshEvent(epgEvents, defaultChannelResponse);
      } else {
        this.props.setFocus(MAIN_MENU);
        this.props.stateActions.setLastFocusedName(MAIN_MENU);
        this.props.resumeNavigation();
      }
    } catch (error) {
      this.props.setFocus(MAIN_MENU);
      this.props.stateActions.setLastFocusedName(MAIN_MENU);
      this.props.resumeNavigation();
      console.log(error);
      this.setState({ loading: false });
    }
  }

  async loadLivePageDataWithCategory(categoryParam = null) {
    document.addEventListener("keydown", this.navigation, false);
    this.resetIndexState();
    this.epgStartTime = getUnixTime(getEpgTime(-6)); // from previous 6 hrs
    this.epgEndTime = getUnixTime(getEpgTime(9)); // to next 9 hrs

    try {
      this.setState({ loading: true });

      // Load categories first
      let categoriesConfigs = await getEpgCategories({
        profileType: getAppState()?.currentProfileType,
        xgeoCountry: getAppState()?.country.toUpperCase(),
        avoidCache: true
      });

      this.categoryFromCacheObj = setCacheKeyForCategories(categoriesConfigs.data);

      // If categoryParam is provided, try to select that specific category
      if (categoryParam) {
        // Find matching category
        const matchingCategory = categoriesConfigs.data.find(
          category =>
            category.slug === categoryParam ||
            category.key === categoryParam ||
            category.label.toLowerCase() === categoryParam.toLowerCase()
        );

        if (matchingCategory) {
          // Load data for specific category
          const categoryValue = matchingCategory.value || matchingCategory.slug;
          const isAllCategory = categoryValue.split(",").length > 1;
          const isGetLatestData = isToGetLatestCategoryData(this.state.wholeEpgData, categoryValue, isAllCategory);

          this.setState({
            // epgData: epgDataAccordingToCategories,
            // loading: false,
            currentCategory: categoryValue
          });

          // Load default channel if it's "all" category
          let defaultChannelResponse = isAllCategory
            ? await this.getDefaultChannelEpg(this.epgStartTime, this.epgEndTime, true)
            : null;

          // Load EPG events for the selected category
          let epgEvents = await getEpgEvents({
            category: categoryValue,
            ts_start: this.epgStartTime,
            ts_end: this.epgEndTime,
            profileType: getAppState()?.currentProfileType,
            xgeoCountry: getAppState()?.country.toUpperCase(),
            page: 1,
            limit: EPG_API_CHANNEL_LIMIT,
            avoidCache: isGetLatestData
          });

          // Embed user data
          epgEvents = epgEvents && (await this.embedUserDataToEpg(epgEvents));
          defaultChannelResponse = defaultChannelResponse && (await this.embedUserDataToEpg(defaultChannelResponse));

          // Get EPG data according to categories
          let epgDataAccordingToCategories = this.getEpgDataAccordingToCategories(categoriesConfigs.data, epgEvents);

          // Add default channel if available
          if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
            const defaultChannel = defaultChannelResponse.data[0];
            this.setState({ defaultChannel: defaultChannel });
            defaultChannel &&
              epgDataAccordingToCategories.unshift(
                this.embedDefaultChannelDataToEpg(defaultChannel, categoriesConfigs.data)
              );
            this.defaultChannelAutoPlay = true;
          }

          if (epgDataAccordingToCategories.length !== 0) {
            const _addToMyListData = await this.getMediaListForEPG();
            const _favoriteChannelList = await this.getFavoriteListForEPG();

            // Set category index
            const categoryIndex = categoriesConfigs.data.findIndex(cat => cat.slug === matchingCategory.slug);
            if (categoryIndex !== -1) {
              this.props.stateActions.setSelectedEpgCategoryIndex(categoryIndex);
              this.changeViewRowIndex = 0;
              this.currentRowIndex = 0;
              this.categoryIndex = categoryIndex;
              this.indexes.categoryIndex = categoryIndex;
            }

            this.props.setFocus(epgGridName);
            this.props.stateActions.setLastFocusedName(epgGridName);
            this.props.pauseNavigation();
            this.setInactiveSubscriptionForFirstChannel(epgDataAccordingToCategories);

            this.setState(
              {
                categories: this.extendEpgCategories(
                  categoriesConfigs,
                  getEpgCategoriesSlugsString(categoriesConfigs.data)
                ),
                epgData: epgDataAccordingToCategories,
                wholeEpgData: epgDataAccordingToCategories,
                loading: false,
                addToMyListData: _addToMyListData,
                favoriteChannelList: _favoriteChannelList,
                currentCategory: categoryValue
              },
              () => {
                // Directly manipulate DOM to set selected class on the correct category
                this.setCategorySelectionFromParams(categoryParam);
              }
            );

            this.updateVideoMetaData(epgDataAccordingToCategories);
            this.playFromEPG(epgDataAccordingToCategories);
            this.getEpgRefreshEvent(epgEvents, defaultChannelResponse);

            if (this.props.history && this.props.history.location && this.props.history.location.search) {
              this.props.history.location.search = "";
            }
            return;
          }
        }
        if (this.props.history && this.props.history.location && this.props.history.location.search) {
          this.props.history.location.search = "";
        }
      }

      // If no categoryParam or category not found, load default data (existing logic)
      const categoriesCommaSepList = getEpgCategoriesSlugsString(categoriesConfigs.data);

      let defaultChannelResponse = await this.getDefaultChannelEpg(this.epgStartTime, this.epgEndTime, true);
      let epgEvents = await getEpgEvents({
        category: categoriesCommaSepList,
        ts_start: this.epgStartTime,
        ts_end: this.epgEndTime,
        profileType: getAppState()?.currentProfileType,
        xgeoCountry: getAppState()?.country.toUpperCase(),
        avoidCache: true,
        page: 1,
        limit: EPG_API_CHANNEL_LIMIT
      });

      epgEvents = epgEvents && (await this.embedUserDataToEpg(epgEvents));
      defaultChannelResponse = defaultChannelResponse && (await this.embedUserDataToEpg(defaultChannelResponse));
      let epgDataAccordingToCategories = this.getEpgDataAccordingToCategories(categoriesConfigs.data, epgEvents);

      if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
        const defaultChannel = defaultChannelResponse.data[0];
        this.setState({ defaultChannel: defaultChannel });
        defaultChannel &&
          epgDataAccordingToCategories.unshift(
            this.embedDefaultChannelDataToEpg(defaultChannel, categoriesConfigs.data)
          );
        this.defaultChannelAutoPlay = true;
      }

      if (epgDataAccordingToCategories.length !== 0) {
        const _addToMyListData = await this.getMediaListForEPG();
        const _favoriteChannelList = await this.getFavoriteListForEPG();
        this.props.setFocus(epgGridName);
        this.props.stateActions.setLastFocusedName(epgGridName);
        this.props.pauseNavigation();
        this.setInactiveSubscriptionForFirstChannel(epgDataAccordingToCategories);
        this.setState({
          categories: this.extendEpgCategories(categoriesConfigs, categoriesCommaSepList),
          epgData: epgDataAccordingToCategories,
          wholeEpgData: epgDataAccordingToCategories,
          loading: false,
          addToMyListData: _addToMyListData,
          favoriteChannelList: _favoriteChannelList,
          currentCategory: categoriesCommaSepList
        });
        this.updateVideoMetaData(epgDataAccordingToCategories);
        this.playFromEPG(epgDataAccordingToCategories);
        this.getEpgRefreshEvent(epgEvents, defaultChannelResponse);
      } else {
        this.props.setFocus(MAIN_MENU);
        this.props.stateActions.setLastFocusedName(MAIN_MENU);
        this.props.resumeNavigation();
      }
    } catch (error) {
      this.props.setFocus(MAIN_MENU);
      this.props.stateActions.setLastFocusedName(MAIN_MENU);
      this.props.resumeNavigation();
      console.log(error);
      this.setState({ loading: false });
    }
  }
  startSignupInactivePromptTimer = () => {
    if (this.signupInactivePromptTimer !== null) clearTimeout(this.signupInactivePromptTimer);
    this.signupInactivePromptTimer = setTimeout(() => {
      const hasAnyModalOpened = getAppState()?.globalModal;
      if (!hasAnyModalOpened || (hasAnyModalOpened && Object.keys(hasAnyModalOpened).length == 0)) {
        const focusPath = showSignupPremiumPrompt.call(this, getNavigationReferences.call(this), this.hideEpgModal);
        this.setFocusAfterModalOpen(focusPath);
      }
    }, getAppState().signupPromptTimer || 5000);
  };

  getUserLoggedStatus = async () => {
    return getAppState()?.userLogged;
  };

  resetIndexState() {
    this.indexes = {
      rowIndex: 0,
      colIndex: 0,
      categoryIndex: 0
    };

    //reset indexes
    this.changeViewRowIndex = 0;
    this.currentRowIndex = 0;
    this.categoryIndex = 0;
    this.setState({ epgCurrentViewIndex: 0 });
  }
  async componentWillUnmount() {
    document.removeEventListener("keydown", this.navigation, false);
    await this.clearPrompt();
    this.resetComponentData();
  }

  async getLiveIndex() {
    const self = this;
    const events = this.state?.epgData?.[this.indexes?.categoryIndex]?.data?.[this.indexes?.rowIndex]?.events;

    if (!events || !Array.isArray(events)) {
      console.warn("No events found for the current indexes:", this.indexes);
      return;
    }

    events.forEach(function(event, index) {
      if (event.status === EVENT_STATUS.live) {
        self.currentLiveIndex = index;
      }
    });
  }

  async clearPrompt() {
    if (this.signupInactivePromptTimer) {
      clearTimeout(this.signupInactivePromptTimer);
    }
  }

  async getMediaListForEPG() {
    const mediaList = await getUserMyList.call(this);
    const mediaListWithOnlyIds = [];
    mediaList &&
      mediaList.length > 0 &&
      mediaList.forEach(element => {
        mediaListWithOnlyIds.push(element.id);
      });
    return mediaListWithOnlyIds;
  }

  async getFavoriteListForEPG() {
    const favList = await getUserFavoriteEpgChannels.call(this);
    return favList;
  }

  async refreshGridData() {
    const { categories, currentCategory } = this.state;
    this.resetIndexState();
    this.epgStartTime = getUnixTime(getEpgTime(-6)); // from pervious 6 hrs
    this.epgEndTime = getUnixTime(getEpgTime(9)); // to next 9 hrs
    try {
      const isAllCategory = currentCategory.split(",").length > 1 ? true : false;
      let defaultChannelResponse = isAllCategory
        ? await this.getDefaultChannelEpg(this.epgStartTime, this.epgEndTime, true)
        : null;
      let categoriesWithFavorite = null;
      if (isNewFavoriteAdded) {
        let categoriesConfigs = await getEpgCategories({
          profileType: getAppState()?.currentProfileType,
          xgeoCountry: getAppState()?.country.toUpperCase(),
          avoidCache: true
        });
        categoriesWithFavorite = getEpgCategoriesSlugsString(categoriesConfigs.data);
        const categoriesCommaSepList = getEpgCategoriesSlugsString(categoriesConfigs.data);
        this.setState({
          categories: this.extendEpgCategories(categoriesConfigs, categoriesCommaSepList)
        });
      }

      // throw new Error();
      let epgEvents = await getEpgEvents({
        category: categoriesWithFavorite
          ? categoriesWithFavorite
          : isAllCategory
          ? categories.find(category => category.key === all).slug
          : currentCategory,
        ts_start: this.epgStartTime,
        ts_end: this.epgEndTime,
        profileType: getAppState()?.currentProfileType,
        xgeoCountry: getAppState()?.country.toUpperCase(),
        page: 1,
        limit: EPG_API_CHANNEL_LIMIT,
        avoidCache: true
      });

      isNewFavoriteAdded = false;

      epgEvents = await this.embedUserDataToEpg(epgEvents);
      defaultChannelResponse = defaultChannelResponse && (await this.embedUserDataToEpg(defaultChannelResponse));

      let epgDataAccordingToCategories = this.getEpgDataAccordingToCategories(categories, epgEvents);
      if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
        const defaultChannel = defaultChannelResponse.data[0];
        defaultChannel &&
          epgDataAccordingToCategories.unshift(this.embedDefaultChannelDataToEpg(defaultChannel, categories));
        this.defaultChannelAutoPlay = true;
      }
      if (epgDataAccordingToCategories.length !== 0) {
        this.props.setFocus(epgGridName);
        this.props.stateActions.setLastFocusedName(epgGridName);
        this.props.pauseNavigation();
        this.setState({
          epgData: epgDataAccordingToCategories,
          isGridLoading: false
        });
        // this.clearRefreshTimeout && clearTimeout(this.clearRefreshTimeout);
        this.getEpgRefreshEvent(epgEvents, defaultChannelResponse);
      } else {
        this.props.setFocus(MAIN_MENU);
        this.props.stateActions.setLastFocusedName(MAIN_MENU);
        this.props.resumeNavigation();
      }
    } catch (error) {
      this.props.setFocus(MAIN_MENU);
      this.props.stateActions.setLastFocusedName(MAIN_MENU);
      this.props.resumeNavigation();
      console.log(error);
      this.setState({ loading: false, isGridLoading: false });
    }
  }

  resetComponentData = () => {
    // if (this.clearRefreshTimeout) {
    //   clearTimeout(this.clearRefreshTimeout);
    // }
    this.clearRefreshTime();
    this.clearRefreshTimeout = null;
    this.resetIndexState();
  };

  findFirstGreaterThanNumber(arr, number) {
    const firstGreaterThan = arr.find(item => item > number);
    return firstGreaterThan !== undefined ? firstGreaterThan : null;
  }

  async getEpgRefreshEvent(epgCategoriesEvents, defaultChannelResponse) {
    this.clearRefreshTime();
    if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
      const defaultChannel = defaultChannelResponse.data[0];
      defaultChannel && epgCategoriesEvents.data.unshift(defaultChannel);
    }
    if (epgCategoriesEvents.data.length > 0) {
      let allLiveEventsTsEnds = epgCategoriesEvents.data.map(categoryEvent => {
        const liveEvent = categoryEvent.events.find(event => event.status === EVENT_STATUS.live);
        return liveEvent && liveEvent.tsEnd > 0 && liveEvent.tsEnd * 1000;
      });
      allLiveEventsTsEnds = [...allLiveEventsTsEnds.filter(Boolean)];
      this.setRefreshEpgEvent(allLiveEventsTsEnds);
    }
  }

  async setRefreshEpgEvent(allLiveEventsTsEnds) {
    const currentDate = new Date();

    const smallestProgramMilliSeconds = Math.min(...allLiveEventsTsEnds);
    const endDate = new Date(smallestProgramMilliSeconds);
    let refreshTime = (endDate.getTime() - currentDate.getTime()) / 1000;
    // refreshTime = 15; // TODO: remove after testing
    if (refreshTime > -1) {
      this.setState({
        refreshTime: refreshTime
      });
      await this.reloadWait(Math.abs(refreshTime) * 1000);
      await this.reloadLivePageData();
    } else {
      const smallestProgramIndex = allLiveEventsTsEnds.indexOf(smallestProgramMilliSeconds);
      allLiveEventsTsEnds.splice(smallestProgramIndex, 1);
      this.setRefreshEpgEvent(allLiveEventsTsEnds);
    }
  }

  async reloadLivePageData() {
    this.setState({
      isGridLoading: true,
      isExiting: false
    });
    this.isEpgRefresh = true;
    this.hideEpgModal();
    await this.refreshGridData();
    this.setState(
      () => ({ isGridLoading: false }),
      () => {
        setTimeout(() => {
          this.isEpgRefresh = false;
        }, 100);
      }
    );
    // show "switchto"
  }

  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }

  closeConfirmModal() {
    this.setState({ isExiting: false });
    this.props.setFocus(firstCategoryIndexFocus);
  }

  async getDefaultChannelEpg(startTime, endTime, avoidCache) {
    try {
      let defaultChannelEpg = await firstPlaybackChannelEventsService({
        ts_start: startTime,
        ts_end: endTime,
        profileType: getAppState()?.currentProfileType,
        xgeoCountry: getAppState()?.country.toUpperCase(),
        avoidCache: avoidCache
      });
      return defaultChannelEpg;
    } catch (error) {
      console.log("error :", error);
    }
  }

  getEpgDataAccordingToCategories(categoriesConfigs, epgEvents) {
    return categoriesConfigs
      .map(category => {
        const matchingChannels = epgEvents.data && epgEvents.data.filter(channel => category.slug === channel.category);

        if (matchingChannels.length > 0) {
          return {
            heading: category,
            data: matchingChannels
          };
        }

        return null;
      })
      .filter(Boolean);
  }

  embedDefaultChannelDataToEpg(defaultChannel, allCategories) {
    let defaultCategory = null;
    if (defaultChannel.preferredCategory) {
      const { icon, label, slug } = defaultChannel.preferredCategory || {};

      defaultCategory = {
        label: label[i18n.getLocale()] || label,
        slug: slug,
        icon: icon
      };
    } else {
      // Add Featured Category
      defaultCategory = allCategories.find(category => category.slug === "featured");
    }

    return {
      heading: defaultCategory,
      data: [defaultChannel]
    };
  }

  async embedUserDataToEpg(epgData) {
    const {
      applicationState: { userLogged, addons, isGuestProfile }
    } = this.props;
    for (let [index] of epgData?.data?.entries()) {
      const addOnData = epgData.data[index];
      let subscriptionName = getSubscriptionNameForModal.call(this, addOnData);
      let isUserSubscribedToAsset = isUserSubscribedToChannel(addons, subscriptionName, addOnData.subscription);
      const multiTaggedAddOnContent = getMultiTaggedAddOnContent.call(
        this,
        isUserSubscribedToAsset,
        subscriptionName,
        addOnData.subscriptionPerCountry
      );
      isUserSubscribedToAsset = isUserSubscribedToChannel(addons, multiTaggedAddOnContent, addOnData.subscription);
      const addonContent = isUserSubscribedToAsset?.name || isUserSubscribedToAsset || "";
      if (userLogged) {
        if (!addOnData.paid) {
          addOnData.isUserSubscribedToChannel = true; // true
          addOnData.rowIndex = index;
        } else {
          const isThisDeviceSupported = await isSupportedDeviceForMobileLite.call(this, addonContent);
          if (!isThisDeviceSupported) {
            addOnData.isThisDeviceSupported = true;
          }
          if (isUserSubscribedToAsset) {
            addOnData.isUserSubscribedToChannel = true; // true
            addOnData.rowIndex = index;
          } else {
            addOnData.isUserSubscribedToChannel = false;
            addOnData.rowIndex = index;
          }
        }
      } else if (isGuestProfile) {
        // Guest User
        addOnData.isUserSubscribedToChannel = !addOnData.paid;
        addOnData.rowIndex = index;
      } else {
        addOnData.isUserSubscribedToChannel = true;
        addOnData.rowIndex = index;
      }
    }
    return epgData;
  }

  extendEpgCategories(categoriesConfigs, slug) {
    categoriesConfigs &&
      categoriesConfigs.data &&
      categoriesConfigs.data.unshift({
        label: i18n.get("pages.livePage.categories.all"),
        slug: slug,
        order: 0,
        key: all
      });

    const extendedCategories = categoriesConfigs?.data.map(category => {
      return {
        ...category,
        tagTitle: category.label,
        value: category.slug
      };
    });
    return extendedCategories;
  }

  navigation = async event => {
    this.setState({ wheelState: "idle" });

    if (this.state.isExiting) {
      this.props.resumeNavigation();
      return;
    }

    if (this.state.isFullScreen === true) {
      // if back btn is entered
      if (this.state.onFullScreen === true && this.state.playerButtonEnter === "back" && event.keyCode === 13) {
        this.setState(
          {
            isFullScreen: false,
            playFromStart: false
          },
          () => {
            this.props.pauseNavigation();
            this.props.setFocus(epgGridName);
          }
        );
      } //else disable for all
      return;
    }
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      if (event.keyCode === 37) {
        // Left key
        if (this.props.applicationState.currentFocus.split("_")[0] === PREFIX_CATEGORY) {
          this.props.setFocus(epgGridName);
          this.props.stateActions.setLastFocusedName(epgGridName);
          this.props.pauseNavigation();
        } else if (this.props.applicationState.currentFocus === headerFocusPath) {
          this.props.setFocus(`${PREFIX_CATEGORY}_${this.props.applicationState.selectedEpgCategoryIndex}`);
        }
      }
      if (event.keyCode === 39) {
        //Right key
        if (this.props.applicationState.currentFocus === epgGridName) {
          this.props.pauseNavigation();
        }
      }
    } else if (i18n.getDirection() === directions.LEFT_TO_RIGHT) {
      if (event.keyCode === 37) {
        // Left key
        if (this.props.applicationState.currentFocus === epgGridName) {
          this.props.pauseNavigation();
        }
      }
      if (event.keyCode === 39) {
        //Right key
        if (this.props.applicationState.currentFocus.split("_")[0] === PREFIX_CATEGORY) {
          this.props.setFocus(epgGridName);
          this.props.stateActions.setLastFocusedName(epgGridName);
          this.props.pauseNavigation();
        } else if (this.props.applicationState.currentFocus === headerFocusPath) {
          this.props.setFocus(`${PREFIX_CATEGORY}_${this.props.applicationState.selectedEpgCategoryIndex}`);
        }
      }
    }

    // up key
    if (event.keyCode === 38 && this.state.isExiting === false) {
      if (this.props.applicationState.currentFocus === firstCategoryIndexFocus) {
        this.props.pauseNavigation();
      } else if (this.props.applicationState.currentFocus === epgGridName) {
        this.props.pauseNavigation();
      }
    }

    // down key
    if (event.keyCode === 40) {
      this.props.resumeNavigation();
      if (this.props.applicationState.currentFocus === epgGridName && this.state.isExiting === false) {
        this.props.pauseNavigation();
      }
    }

    // enter key
    if (event.keyCode === 13) {
      if (this.props.applicationState.currentFocus === epgGridName && this.indexes.colIndex > -1) {
        const { currentVideoMetaData, previousVideoMetaData } = this.updateVideoMetaData(this.state.epgData);
        // if user unsubscribe, show him modal
        if (!currentVideoMetaData.isUserSubscribedToChannel) {
          const {
            applicationState: { userLogged, addons }
          } = this.props;
          const { displayName, action } = getInActiveSubscriptionDisplayName.call(
            this,
            currentVideoMetaData.currentChannel
          );
          this.setState({
            inActiveSubscriptionName: displayName,
            inActiveSubscriptionAction: action
          });
          const currentProfile = await getCurrentProfile();
          const kidsProfileEnabled = currentProfile.profileCategory === "KIDS" ? true : false;

          let subName = getSubscriptionNameForModal.call(this, currentVideoMetaData.currentChannel);
          const brndInfo = getBuyBrandsInfoObj(addons, subName);
          this.setState({
            brandInfo: {
              btnName: brndInfo?.buttonDisplayName,
              planName: brndInfo?.paymentPlanName,
              subscriptionDisplayName: brndInfo?.subscriptionDisplayName
            }
          });
          if (userLogged && kidsProfileEnabled) {
            this.kidsProfileModalOpen = true;
            isAnyModalOpen = true;
            return showContentNotAccessibleModal.call(this, null, {
              isSVODContent: true,
              name: this.state.inActiveSubscriptionName
            });
          }
          await showSubscriptionModal.call(
            this,
            currentVideoMetaData.currentChannel,
            false,
            this.onBack,
            null,
            isChampionsTrophyAddOn(subName)
          );
          return;
        } else if (
          currentVideoMetaData &&
          previousVideoMetaData &&
          currentVideoMetaData.id === previousVideoMetaData.id &&
          !this.state.isError
        ) {
          // 2nd Click
          if (!this.state.playerBuffering) this.showProgramMoreDetailsPopup();
        } else if (
          // if linear & next
          currentVideoMetaData &&
          currentVideoMetaData.channelType === CHANNEL_TYPES.linear &&
          currentVideoMetaData.status === TAG_STATUS.upcoming
        ) {
          this.setState({
            isUpComingLinear: true
          });
          this.showProgramMoreDetailsPopup();
        } else {
          // 1st Click
          this.setState(
            {
              isUpComingLinear: false,
              isError: false,
              playFromResume: 0
            },
            () => {
              this.defaultChannelAutoPlay = false;
              this.playFromEPG(this.state.epgData);
            }
          );
        }
      } else if (this.props.applicationState.currentFocus.split("_")[0] === PREFIX_CATEGORY) {
        this.onClickEpgCategory.call(this);
      }
    }
    // 8 is back pressed from pc and 461 is a back button key code from samsung remote
    if (event.keyCode === 461 || event.keyCode === 8 || this.kidsProfileModalOpen) {
      this.kidsProfileModalOpen = false;
      isAnyModalOpen && this.hideEpgModal();
    }
  };

  onUpdateWheelState(wheelState) {
    this.setState({ wheelState: wheelState });
  }
  checkSystemMagicRemote() {
    getSdk().systemManager.application.checkMagicRemote()
      ? this.setState({ isWheelFromSystem: true })
      : this.setState({ isWheelFromSystem: false });
  }

  /* donot call this method other then onClick */
  async onClickEpgSlots() {
    await this.reloadWait(100);
    const { currentVideoMetaData, previousVideoMetaData } = this.updateVideoMetaData(this.state.epgData);
    // if user unsubscribe, show him modal
    if (!currentVideoMetaData.isUserSubscribedToChannel) {
      const {
        applicationState: { userLogged }
      } = this.props;
      const { displayName, action } = getInActiveSubscriptionDisplayName.call(
        this,
        currentVideoMetaData.currentChannel
      );
      this.setState({
        inActiveSubscriptionName: displayName,
        inActiveSubscriptionAction: action
      });
      const currentProfile = await getCurrentProfile();
      const kidsProfileEnabled = currentProfile.profileCategory === "KIDS" ? true : false;
      if (userLogged && kidsProfileEnabled) {
        isAnyModalOpen = true;
        return showContentNotAccessibleModal.call(this, this.hideEpgModal, {
          isSVODContent: true,
          name: this.state.inActiveSubscriptionName
        });
      }
      let subName = getSubscriptionNameForModal.call(this, currentVideoMetaData.currentChannel);
      const subscriptionName = await showSubscriptionModal.call(
        this,
        currentVideoMetaData.currentChannel,
        false,
        this.onBack,
        null,
        isChampionsTrophyAddOn(subName)
      );
      this.setState({
        inActiveSubscriptionName: subscriptionName
      });
      return;
    } else if (
      currentVideoMetaData &&
      previousVideoMetaData &&
      currentVideoMetaData.id === previousVideoMetaData.id &&
      !this.state.isError
    ) {
      // 2nd Click
      if (!this.state.playerBuffering) this.showProgramMoreDetailsPopup();
    } else if (
      // if linear & next
      currentVideoMetaData &&
      currentVideoMetaData.channelType === CHANNEL_TYPES.linear &&
      currentVideoMetaData.status === TAG_STATUS.upcoming
    ) {
      this.setState({
        isUpComingLinear: true
      });
      this.showProgramMoreDetailsPopup();
    } else {
      // 1st Click
      this.setState(
        {
          isUpComingLinear: false,
          isError: false,
          playFromResume: 0
        },
        () => {
          this.defaultChannelAutoPlay = false;
          this.playFromEPG(this.state.epgData);
        }
      );
    }
  }

  async onClickEpgCategory(index) {
    const { categories, wholeEpgData } = this.state;
    const liValue =
      index > -1 ? this.state.categories[index]?.value : document.querySelector("li.focused").getAttribute("value");
    const isAllCategory = liValue.split(",").length > 1 ? true : false;
    const isGetLatestData = isToGetLatestCategoryData(wholeEpgData, liValue, isAllCategory);

    const allCategoryItems = document.querySelectorAll("li[value]");
    allCategoryItems.forEach(item => {
      item.classList.remove("selected");
    });

    // Show loader while fetching data
    this.setState({ isGridLoading: true });

    let defaultChannelResponse = isAllCategory
      ? await this.getDefaultChannelEpg(this.epgStartTime, this.epgEndTime, true)
      : null;
    let epgEvents = await getEpgEvents({
      category: liValue,
      ts_start: this.epgStartTime,
      ts_end: this.epgEndTime,
      profileType: getAppState()?.currentProfileType,
      xgeoCountry: getAppState()?.country.toUpperCase(),
      page: 1,
      limit: EPG_API_CHANNEL_LIMIT,
      avoidCache: isGetLatestData
    });
    epgEvents = epgEvents && (await this.embedUserDataToEpg(epgEvents));
    defaultChannelResponse = defaultChannelResponse && (await this.embedUserDataToEpg(defaultChannelResponse));
    let epgDataAccordingToCategories = this.getEpgDataAccordingToCategories(categories, epgEvents);
    if (defaultChannelResponse && defaultChannelResponse.data.length > 0) {
      const defaultChannel = defaultChannelResponse.data[0];
      defaultChannel &&
        epgDataAccordingToCategories.unshift(this.embedDefaultChannelDataToEpg(defaultChannel, categories));
    }

    this.getEpgRefreshEvent(epgEvents, defaultChannelResponse);
    this.setState({
      epgData: epgDataAccordingToCategories,
      loading: false,
      currentCategory: liValue,
      isGridLoading: false
    });
    this.props.setFocus(epgGridName);
    this.props.stateActions.setLastFocusedName(epgGridName);
    if (this.state.epgCurrentViewIndex === 1) this.setState({ epgCurrentViewIndex: 0 });
    this.props.pauseNavigation();
    //reset indexes
    this.changeViewRowIndex = 0;
    this.currentRowIndex = 0;
    this.categoryIndex = 0;
  }

  clearRefreshTime() {
    clearTimeout(this.clearRefreshTimeout);
    this.setState({
      refreshTime: null
    });
  }

  async playFromEPG(epgData) {
    const epgDataEvents = this.state.epgCurrentViewIndex === 1 ? epgData : reduceDataForStaticView([...epgData]);
    const event = epgDataEvents[this.indexes.categoryIndex].data[this.indexes.rowIndex]?.events[this.indexes.colIndex];
    if (event?.streamingUrl.length !== 0) {
      let videoData = await this.getVideoDataForEPG(isSuitableFor4KPlayback(has4KProgramId.call(this)), epgDataEvents);
      this.setState({ videoData: videoData }, () => this.showToolTip());
    }
  }

  showToolTip() {
    if (this.state.currentVideoMetaData && this.state.currentVideoMetaData.isUserSubscribedToChannel) {
      setTimeout(() => {
        this.setState({ isShowTooltip: true }, () => {
          setTimeout(() => {
            this.setState({ isShowTooltip: false });
          }, EPG_TOOLTIP_HIDE_TIME);
        });
      }, EPG_TOOLTIP_SHOW_FIRST_TIME);
    }
  }

  getStreamingUrlDefault(streamingUrl) {
    let format = WIDEVINE_FORMATS.withoutAd;
    let filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    return filteredUrls;
  }

  getStreamingUrlWithOutAd(streamingUrl, dPlay) {
    const formatMap = {
      [DPLAY.free]: WIDEVINE_FORMATS.withoutAdnonDrm,
      [DPLAY.token]: WIDEVINE_FORMATS.withoutAdnonDrmProtected,
      default: WIDEVINE_FORMATS.withoutAd
    };
    let format = formatMap[dPlay] || formatMap.default;
    let filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);

    if (filteredUrls.length === 0) {
      format = WIDEVINE_FORMATS.withoutAd;
      filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    }
    return filteredUrls;
  }

  getStreamingUrlWithAd(streamingUrl, dPlay) {
    const formatMap = {
      [DPLAY.free]: WIDEVINE_FORMATS.withAdnonDrm,
      [DPLAY.token]: WIDEVINE_FORMATS.withAdnonDrmProtected,
      default: WIDEVINE_FORMATS.withAd
    };
    let format = formatMap[dPlay] || formatMap.default;
    let filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);

    if (filteredUrls.length === 0) {
      format = WIDEVINE_FORMATS.withAd;
      filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    }

    if (filteredUrls.length === 0) {
      format = WIDEVINE_FORMATS.withoutAd;
      filteredUrls = streamingUrl.filter(type => type.assetTypes[0] === format);
    }

    return filteredUrls;
  }

  getCalculatedDPlay(dplay, adsCountryRights, withAd, withoutAd, enforceAds = false) {
    const isSVODUser = getAppState()?.isSvodUser;
    const isShowAds = !isSVODUser ? true : enforceAds && isSVODUser ? true : false;
    const isAdExist = isShowAds && adsCountryRights && adsCountryRights.indexOf(this.adCountry) > -1 ? true : false;
    if (dplay) {
      if (dplay === DPLAY.free) {
        const value =
          (isAdExist && withAd.assetTypes[0] === WIDEVINE_FORMATS.withAdnonDrm) ||
          (!isAdExist && withoutAd.assetTypes[0] === WIDEVINE_FORMATS.withoutAdnonDrm)
            ? DPLAY.free
            : null;
        return value;
      } else if (dplay === DPLAY.token) {
        const value =
          (isAdExist && withAd.assetTypes[0] === WIDEVINE_FORMATS.withAdnonDrmProtected) ||
          (!isAdExist && withoutAd.assetTypes[0] === WIDEVINE_FORMATS.withoutAdnonDrmProtected)
            ? DPLAY.token
            : null;
        return value;
      }
    } else return null;
  }

  isPlayableContent(event, channelDetails) {
    return (
      (event.status === EVENT_STATUS.live && channelDetails.type === CHANNEL_TYPES.linear) ||
      (event.status === EVENT_STATUS.ended && channelDetails.type === CHANNEL_TYPES.linear) ||
      (event.status === EVENT_STATUS.ended && channelDetails.type === CHANNEL_TYPES.playlist) ||
      (event.status === EVENT_STATUS.upcoming && channelDetails.type === CHANNEL_TYPES.playlist) ||
      (event.status === EVENT_STATUS.live && channelDetails.type === CHANNEL_TYPES.playlist)
    );
  }

  getResumeTime(event, channelDetails, endTime, startTime) {
    if (event.status === EVENT_STATUS.live && channelDetails.type === CHANNEL_TYPES.playlist) {
      const currentDate = new Date();
      const totalTime = endTime - startTime;
      const remainingTime = totalTime - (endTime - currentDate.getTime());
      return remainingTime / TIME_TO_MILLISECONDS;
    } else {
      return 0;
    }
  }

  getVideoDataForEPG = async (is4K, epgDataEvents) => {
    let videoData = {};
    const event = epgDataEvents[this.indexes.categoryIndex].data[this.indexes.rowIndex].events[this.indexes.colIndex];
    const channelDetails = epgDataEvents[this.indexes.categoryIndex].data[this.indexes.rowIndex];
    const startTime = event.tsStart * TIME_TO_MILLISECONDS;
    const endTime = event.tsEnd * TIME_TO_MILLISECONDS;

    const resumeTime = this.getResumeTime(event, channelDetails, endTime, startTime);
    const today = new Date();
    const streamingUrlWithoutAd = this.getStreamingUrlWithOutAd(event.streamingUrl, channelDetails.config?.dPlay);
    const streamingUrlWithAd = this.getStreamingUrlWithAd(event.streamingUrl, channelDetails.config?.dPlay);
    const getModelDevice = await getSdk().systemManager.device.getRealModel();

    const streamingUrlDefault = this.getStreamingUrlDefault(event.streamingUrl);
    const contentOwnership =
      channelDetails.contentOwnership && channelDetails.contentOwnership.length > 0
        ? channelDetails.contentOwnership[0]
        : STARZ;
    if (this.isPlayableContent(event, channelDetails)) {
      if (event && channelDetails) {
        videoData = {
          videoType: "movie",
          contentTypeYoubora: "movie",
          manifest: streamingUrlDefault[0].url,
          releasePid: streamingUrlDefault[0].pid,
          releaseUrl: "http://link.theplatform.eu/s/qaJAph/" + streamingUrlDefault[0].pid,
          duration: event.duration,
          adsCountryRights: channelDetails.adsCountryRights || [],
          dPlay: this.getCalculatedDPlay(
            channelDetails.config?.dPlay,
            channelDetails?.adsCountryRights,
            streamingUrlWithAd[0],
            streamingUrlWithoutAd[0],
            channelDetails.config?.enforceAds
          ),
          dash_widevine_ads: streamingUrlWithAd[0] || [],
          dash_widevine_Without_ads: streamingUrlWithoutAd[0] || [],
          filmstrip: undefined,
          playlist: channelDetails.type === CHANNEL_TYPES.playlist ? channelDetails.events : null,
          currentPlaylistIndex: channelDetails.type === CHANNEL_TYPES.playlist ? this.indexes.colIndex : -1,
          channelType: channelDetails.type,
          guid: event.guid,

          contentType: channelDetails.paid ? CHANNEL_PLAN.svod : CHANNEL_PLAN.avod,
          contentOwnership,
          profileType: getAppState().currentProfileType,

          onlineContent: "online",
          title: event.title,
          description: event.description,
          playbackTime: resumeTime,
          id: channelDetails.type === CHANNEL_TYPES.linear ? channelDetails.id : event.id,
          has4K: is4K,
          externalSubtitles: {},
          addonContent:
            today >= startTime && today >= endTime
              ? channelDetails.parent_slug || "starz"
              : channelDetails.parent_slug
              ? channelDetails.parent_slug
              : channelDetails.slug,
          isLive: event.status === EVENT_STATUS.live && channelDetails.type === CHANNEL_TYPES.linear ? true : false,
          isWatchNow:
            event.status === EVENT_STATUS.live && channelDetails.type === CHANNEL_TYPES.playlist ? true : false,
          subscription: channelDetails.subscription || [],
          subscriptionPerCountry: channelDetails.subscriptionPerCountry || {},
          genres: event.genres,
          backgroundCover: event.images[0]?.url,
          assetTypes:
            event?.assetTypes && event?.assetTypes.length > 0
              ? event?.assetTypes
              : channelDetails?.assetTypes && channelDetails?.assetTypes.length > 0
              ? channelDetails?.assetTypes
              : null,
          content_language: event?.languages?.[0] ?? "en",
          content_rating: channelDetails.parentalControl.toString(),
          device_model: getModelDevice,
          enforceAds: this.props.applicationState.isSvodUser ? channelDetails?.config?.enforceAds || false : false
        };
      }
      return videoData;
    } else {
      return {};
    }
  };

  updateVideoMetaData(epgData) {
    const { categoryIndex, rowIndex, colIndex } = this.indexes;
    const epgDataEvents = this.state.epgCurrentViewIndex === 1 ? epgData : reduceDataForStaticView([...epgData]);
    const videoMetaData = getVideoMetaData(epgDataEvents, categoryIndex, rowIndex, colIndex);
    const returnedObj = {
      currentVideoMetaData: videoMetaData,
      previousVideoMetaData: { ...this.state.currentVideoMetaData }
    };
    this.setState({
      currentVideoMetaData: videoMetaData,
      previousVideoMetaData: { ...this.state.currentVideoMetaData }
    });
    return returnedObj;
  }

  setInactiveSubscriptionForFirstChannel(epgData) {
    const firstChannel = epgData.length > 0 && epgData[0].data && epgData[0].data.length > 0 && epgData[0].data[0];
    if (firstChannel) {
      const { displayName, action } = getInActiveSubscriptionDisplayName.call(this, firstChannel);
      this.setState({
        inActiveSubscriptionName: displayName,
        inActiveSubscriptionAction: action
      });
    }
  }

  hideEpgModal() {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    if (isAnyModalOpen) {
      hideGlobalModal();
      this.props.pauseNavigation();
      this.props.setFocus(epgGridName);
    }
    if (getAppState().signupPromptActive) {
      getAppState().signupPromptActive = false;
    }
    isAnyModalOpen = false;
  }

  showChannelDetailsModal() {
    const { stateActions } = this.props;
    stateActions.hideGlobalModal();
    this.showProgramMoreDetailsPopup(true);
  }

  async isNextVideoPlaying() {
    const epgDataEvents =
      this.state.epgCurrentViewIndex === 1 ? this.state.epgData : reduceDataForStaticView([...this.state.epgData]);
    const event = epgDataEvents[this.indexes.categoryIndex].data[this.indexes.rowIndex]?.events[this.indexes.colIndex];
    const channelDetails = this.state.epgData[this.indexes.categoryIndex].data[this.indexes.rowIndex];
    if (channelDetails.type === CHANNEL_TYPES.playlist && this.state.videoData.guid !== event.guid) {
      if (event?.streamingUrl.length !== 0) {
        let videoData = await this.getVideoDataForEPG(
          isSuitableFor4KPlayback(has4KProgramId.call(this)),
          epgDataEvents
        );
        this.setState({ videoData: videoData });
      }
    }
  }

  watchFromStart = status => {
    this.isNextVideoPlaying();
    if (status === EVENT_STATUS.ended || status === EVENT_STATUS.upcoming) {
      // watch that Program from Start
      this.setState(
        {
          playFromStart: true
        },
        () => {
          this.goPlayer();
        }
      );
    } else if (status === EVENT_STATUS.watchNow) {
      // watch that Program from Start
      this.setState(
        {
          playFromStart: true
        },
        () => {
          this.goPlayer();
        }
      );
    }
  };

  watchLiveChannel = status => {
    this.isNextVideoPlaying();
    if (status === EVENT_STATUS.watchNow || status === EVENT_STATUS.live) {
      // watch that Program from Start
      this.setState(
        {
          playFromStart: false
        },
        () => {
          if (status === EVENT_STATUS.watchNow) {
            this.updateResume();
          }
          this.goPlayer();
        }
      );
    } else if (status === EVENT_STATUS.ended) {
      // watch that Program from currently it was playing
      this.setState(
        {
          playFromStart: false
        },
        () => {
          this.goPlayer();
        }
      );
    }
  };

  goPlayer() {
    this.setState(
      {
        isFullScreen: true
      },
      async () => {
        await this.clearPrompt();
        this.hideEpgModal();
      }
    );
  }

  updateResume() {
    const epgDataEvents =
      this.state.epgCurrentViewIndex === 1 ? this.state.epgData : reduceDataForStaticView([...this.state.epgData]);
    const event = epgDataEvents[this.indexes.categoryIndex].data[this.indexes.rowIndex]?.events[this.indexes.colIndex];

    const channelDetails = this.state.epgData[this.indexes.categoryIndex].data[this.indexes.rowIndex];
    const startTime = event.tsStart * TIME_TO_MILLISECONDS;
    const endTime = event.tsEnd * TIME_TO_MILLISECONDS;

    const resumeTime = this.getResumeTime(event, channelDetails, endTime, startTime);
    this.setState({ playFromResume: resumeTime });
  }

  async addToMyListHandler(isRemoved, titleId) {
    const { addToMyListData } = this.state;
    let _addToMyListData = addToMyListData && addToMyListData.length > 0 ? [...addToMyListData] : [];

    if (isRemoved) {
      _addToMyListData = _addToMyListData.filter(e => e !== titleId);
      await removeFromMediaListFromEPG.call(this, titleId);
    } else if (_addToMyListData.indexOf(titleId) === -1) {
      _addToMyListData.push(titleId);
      await addToMediaListFromEPG.call(this, titleId);
    }

    this.setState(
      {
        addToMyListData: _addToMyListData
      },
      () => {
        this.showProgramMoreDetailsPopup(false, true);
      }
    );
  }

  async favoriteChannelHandler(isRemoved, channelId) {
    const { favoriteChannelList } = this.state;
    let _favoriteChannelList = favoriteChannelList && favoriteChannelList.length > 0 ? [...favoriteChannelList] : [];

    if (isRemoved) {
      _favoriteChannelList = _favoriteChannelList.filter(e => e !== channelId);
      await removeFromFavorite(channelId);
    } else if (_favoriteChannelList.indexOf(channelId) === -1) {
      _favoriteChannelList.push(channelId);
      await addToFavorite(channelId);
    }

    this.setState(
      {
        favoriteChannelList: _favoriteChannelList
      },
      async () => {
        isNewFavoriteAdded = true;
        this.showProgramMoreDetailsPopup(true, false, true);
      }
    );
  }

  getEPGPopupButtons(
    status,
    channelType,
    titleId,
    isShowChannelDetailModal,
    isFromAddToMyList,
    isFromFavoriteChannel = false,
    channelId
  ) {
    let buttons = [];
    let { addToMyListData, favoriteChannelList } = this.state;
    favoriteChannelList = favoriteChannelList || [];
    if (isShowChannelDetailModal) {
      channelType === CHANNEL_TYPES.linear &&
        favoriteChannelList.indexOf(channelId.toString()) !== -1 &&
        buttons.unshift({
          ...getGlobalButtonInfo("removeFromFavorites"),
          buttonHandler: () => this.favoriteChannelHandler.call(this, true, channelId.toString())
        });

      channelType === CHANNEL_TYPES.linear &&
        favoriteChannelList.indexOf(channelId.toString()) === -1 &&
        buttons.unshift({
          ...getGlobalButtonInfo("favoriteChannel"),
          buttonHandler: () => this.favoriteChannelHandler.call(this, false, channelId.toString())
        });

      // Push Watch Live Channel Button
      channelType === CHANNEL_TYPES.linear &&
        status !== EVENT_STATUS.upcoming &&
        buttons.unshift({
          ...getGlobalButtonInfo("watchLiveChannel"),
          buttonHandler: () => this.watchLiveChannel(status)
        });

      // Push Watch Live Channel Button
      channelType === CHANNEL_TYPES.playlist &&
        status !== EVENT_STATUS.upcoming &&
        buttons.unshift({
          ...getGlobalButtonInfo("watchLiveChannel"),
          buttonHandler: () => this.watchLiveChannel(status)
        });
    } else {
      buttons.unshift({
        ...getGlobalButtonInfo("channelDetails"),
        buttonHandler: () => this.showChannelDetailsModal()
      });

      // Push Watch From Start Button
      channelType === CHANNEL_TYPES.playlist &&
        addToMyListData.indexOf(titleId) !== -1 &&
        buttons.unshift({
          ...getGlobalButtonInfo("removeFromMyList"),
          buttonHandler: () => this.addToMyListHandler.call(this, true, titleId)
        });

      channelType === CHANNEL_TYPES.playlist &&
        addToMyListData.indexOf(titleId) === -1 &&
        buttons.unshift({
          ...getGlobalButtonInfo("addToMyList"),
          buttonHandler: () => this.addToMyListHandler.call(this, false, titleId)
        });

      // Push Watch Live Channel Button
      channelType === CHANNEL_TYPES.linear &&
        status !== EVENT_STATUS.upcoming &&
        buttons.unshift({
          ...getGlobalButtonInfo("watchLiveChannel"),
          buttonHandler: () => this.watchLiveChannel(status)
        });

      // Push Watch Live Channel Button
      channelType === CHANNEL_TYPES.playlist &&
        status === EVENT_STATUS.watchNow &&
        buttons.unshift({
          ...getGlobalButtonInfo("watchLiveChannel"),
          buttonHandler: () => this.watchLiveChannel(status)
        });

      // Push Watch From Start Button
      channelType === CHANNEL_TYPES.playlist &&
        buttons.unshift({
          ...getGlobalButtonInfo("watchFromStart"),
          buttonHandler: () => this.watchFromStart(status)
        });
    }

    // const secondLastButton = buttons[buttons.length - 2] && buttons[buttons.length - 2].focusPath;
    // const lastButton = buttons[buttons.length - 1] && buttons[buttons.length - 1].focusPath;
    const firstButton = buttons[0] && buttons[0].focusPath;

    // const addToListPlusFavButtons = isFromAddToMyList ? secondLastButton : lastButton;

    // let focusPath = isFromFavoriteChannel
    //   ? lastButton
    //   : isFromAddToMyList && addToListPlusFavButtons
    //   ? addToListPlusFavButtons
    //   : firstButton;
    const focusPath = firstButton;
    return { buttons, focusPath };
  }

  setFocusAfterModalOpen(focusPath) {
    const { setFocus } = this.props;
    setTimeout(() => {
      this.props.resumeNavigation();
    }, 1);
    setFocus(focusPath);
    isAnyModalOpen = true;
  }

  showProgramMoreDetailsPopup(
    isShowChannelDetailModal = false,
    isFromAddToMyList = false,
    isFromFavoriteChannel = false
  ) {
    this.props.pauseNavigation();
    const { stateActions } = this.props;
    const { currentVideoMetaData } = this.state;
    let {
      title,
      description,
      tsEnd,
      tsStart,
      channelImage,
      status,
      genres,
      parentalControl,
      channelType,
      currentChannel
    } = currentVideoMetaData || {};
    const channelId = currentVideoMetaData?.currentChannel?.id;
    const epgStatus = getStatusTagText(status, channelType);
    const epgRenderStatus = i18n.get(`pages.livePage.tags.${getStatusTagText(status, channelType)}`);
    const epgTime = calculateDurationForSlots(tsStart, tsEnd);
    if (isShowChannelDetailModal) {
      const tagsList = getTagsList(currentChannel?.genres, parentalControl);
      const { buttons, focusPath } = this.getEPGPopupButtons(
        epgStatus,
        channelType,
        currentVideoMetaData.id,
        isShowChannelDetailModal,
        isFromAddToMyList,
        isFromFavoriteChannel,
        channelId
      );

      stateActions.showGlobalModal({
        modalTitle: currentChannel?.title,
        modalText: currentChannel?.description,
        type: EPG_MODAL_TYPES.VERTICAL_SIDEBAR_EPG_POPUP,
        epgTags: getTagsListComponent(tagsList),
        buttons: buttons,
        epgChannelImage: channelImage,
        onClickBack: this.onBack
      });
      this.setFocusAfterModalOpen(focusPath);
    } else {
      const tagsList = getTagsList(genres, parentalControl);
      const { buttons, focusPath } = this.getEPGPopupButtons(
        epgStatus,
        channelType,
        currentVideoMetaData.id,
        isShowChannelDetailModal,
        isFromAddToMyList,
        isFromFavoriteChannel,
        channelId
      );
      stateActions.showGlobalModal({
        modalTitle: title,
        modalText: description,
        type: EPG_MODAL_TYPES.VERTICAL_SIDEBAR_EPG_POPUP,
        epgStatus,
        epgRenderStatus,
        epgTime,
        epgTags: getTagsListComponent(tagsList),
        buttons: buttons,
        onClickBack: this.onBack
      });
      this.setFocusAfterModalOpen(focusPath);
    }
  }

  onChange({
    rowIndex,
    colIndex,
    categoryIndex,
    changeView,
    showRows = null,
    showCat = null,
    currentRowIndex,
    onFullScreen,
    buttonEnter,
    isBack,
    playerBuffering,
    isError,
    errorHeading,
    errorMessage,
    leftOffset,
    rightOffset,
    wheelState
  }) {
    if (getAppState().globalModal || this.state.isExiting === true) return;
    if (changeView) {
      if (this.state.epgCurrentViewIndex === 0) this.setState({ epgCurrentViewIndex: 1 });
      else if (this.state.epgCurrentViewIndex === 1) this.setState({ epgCurrentViewIndex: 0 });
    } else if (colIndex === -1) {
      this.props.setFocus(firstCategoryIndexFocus);
      this.props.stateActions.setLastFocusedName(firstCategoryIndexFocus);
      this.props.resumeNavigation();
    }
    if (changeView) {
      this.changeView = changeView;
      this.changeViewRowIndex = rowIndex;
      this.visibleRows = showRows;
      this.visibleCat = showCat;
      this.categoryIndex = categoryIndex;
      this.currentRowIndex = currentRowIndex;
    } else {
      this.changeView = false;
    }
    this.indexes = {
      rowIndex: rowIndex,
      colIndex: colIndex,
      categoryIndex: categoryIndex
    };

    if (wheelState) {
      this.setState({ wheelState: wheelState });
    }

    this.setState({
      onFullScreen: onFullScreen,
      playerButtonEnter: buttonEnter
    });
    // calls when playback is finish and finish event triggers
    if (isBack) {
      this.setState(
        {
          isFullScreen: false
        },
        () => {
          this.props.pauseNavigation();
          this.props.setFocus(epgGridName);
        }
      );

      if (playerBuffering) {
        this.setState({
          playerBuffering: playerBuffering
        });
      }
    }

    if (isError) {
      this.setState(
        {
          isError: isError ? true : false,
          isFullScreen: this.state.isFullScreen ? false : false,
          errorHeading,
          errorMessage
        },
        () => {
          this.props.pauseNavigation();
          this.props.setFocus(epgGridName);
        }
      );
    }

    if (leftOffset && rightOffset) {
      const scrollableTimeLines = document.querySelector(".timeline");
      scrollableTimeLines.scrollLeft =
        i18n.getDirection() === directions.LEFT_TO_RIGHT
          ? colIndex > 0
            ? leftOffset
            : 0
          : colIndex > 0
          ? rightOffset
          : 4900;

      this.leftOffset = leftOffset;
      this.rightOffset = rightOffset;
    }

    this.props.stateActions.setSelectedEpgCategoryIndex(categoryIndex);
    this.checkSystemMagicRemote();
  }

  onBack() {
    const {
      applicationState: { globalModal }
    } = this.props;
    if (this.state.isExiting) {
      // Close exit popup
      this.closeConfirmModal();
      this.props.setFocus(firstCategoryIndexFocus);
    } else if (this.props.applicationState.currentFocus === MAIN_MENU) {
      if ((!globalModal || globalModal.dismissable) && config.get().featureToggles.exitAppPopup) {
        this.setState({ isExiting: true });
      }
    } else if (this.state.isFullScreen === true) {
      this.setState(
        {
          isFullScreen: false,
          playFromStart: false
        },
        () => {
          this.props.pauseNavigation();
          this.props.setFocus(epgGridName);
        }
      );
    } else if (globalModal && this.state.isFullScreen !== true) {
      this.hideEpgModal();
    } else if (
      this.props.applicationState.currentFocus.split("_")[0] === PREFIX_CATEGORY &&
      this.state.isFullScreen !== true
    ) {
      this.props.setFocus(headerFocusPath);
    } else {
      if (this.state.epgCurrentViewIndex === 0) {
        this.props.setFocus(firstCategoryIndexFocus);
        this.props.stateActions.setLastFocusedName(firstCategoryIndexFocus);
        this.props.resumeNavigation();
        this.changeView = false;
        this.indexes.colIndex = -1;
      } else if (this.state.epgCurrentViewIndex === 1) {
        this.changeView = true;
        this.changeViewRowIndex = this.indexes.rowIndex;
        this.categoryIndex = this.indexes.categoryIndex;
        this.setState({ epgCurrentViewIndex: 0 });
      }
    }
    return true;
  }

  getLiveBarTimeline = () => {
    const todayDate = new Date();
    const startDate = new Date(this.startTime * TIME_TO_MILLISECONDS);
    let differenceHours;
    differenceHours = todayDate.getHours() - startDate.getHours();
    if (differenceHours < 0) {
      // if we are getting time of previous day
      const addPastHours = HOURS_IN_A_DAY - startDate.getHours();
      differenceHours = todayDate.getHours() + addPastHours;
    }
    // to move the bar to the start of live program slot
    const totalRemWidthHours = differenceHours * this.remWidthPerHour;
    // to move the bar from start of the program to current time in minutes
    const totalRemWidthMinutes = todayDate.getMinutes() * this.remWidthPerMinute;
    const totalRemWidth = totalRemWidthHours + totalRemWidthMinutes;
    return totalRemWidth;
  };

  toggleQRCodeModal(showModal) {
    this.setState({
      showQRCodeModal: showModal
    });
  }

  isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  }

  setCategorySelectionFromParams(categoryParam) {
    // Remove selected class from all category items
    const allCategoryItems = document.querySelectorAll("li[value]");
    allCategoryItems.forEach(item => {
      item.classList.remove("selected");
    });

    // Find the category item that matches the parameter and add selected class
    const targetCategoryItem = document.querySelector(`li[value="${categoryParam}"]`);
    if (targetCategoryItem) {
      targetCategoryItem.classList.add("selected");

      setTimeout(() => {
        const categoryContainer = targetCategoryItem.closest("nav") || targetCategoryItem.closest("ul");

        if (categoryContainer) {
          const containerRect = categoryContainer.getBoundingClientRect();
          const itemRect = targetCategoryItem.getBoundingClientRect();
          const scrollTop = targetCategoryItem.offsetTop - categoryContainer.clientHeight / 2 + itemRect.height / 2;

          categoryContainer.scrollTo({
            top: scrollTop,
            behavior: "smooth"
          });
        }
      }, 0);
    }
  }

  render() {
    const {
      epgCurrentViewIndex,
      categories,
      epgData,
      currentVideoMetaData,
      currentCategory,
      videoData,
      isFullScreen,
      isShowTooltip,
      isGridLoading,
      isUpComingLinear,
      wheelState,
      isError,
      errorHeading,
      errorMessage,
      showQRCodeModal
    } = this.state;

    return this.state.loading ? (
      <Loading overlay opacity="0" />
    ) : (
      <>
        {this.state.isExiting && ( // FIXME: make this work with globalModal logic when possible (and the other places where is appears too.
          <ExitModel>
            <ModalSettings
              headingText={i18n.get("global.modals.exit.title")}
              mainText={i18n.get("global.modals.exit.text")}
            >
              <ButtonModalFocus
                label={i18n.get("global.no").toUpperCase()}
                focusPath="noOkModal_passThru"
                onEnterPress={this.closeConfirmModal}
                onMouseUp={this.closeConfirmModal}
                size="small"
                spacing="small"
                onRef={ref => (this.confirmModalFocusPath = ref)}
                dataSnDown={"@okModal_passThru"}
                dataSnUp={""}
                dataSnLeft={""}
                dataSnRight={""}
                displayBlock={true}
              />
              <ButtonModalFocus
                label={i18n.get("global.yes").toUpperCase()}
                focusPath="okModal_passThru"
                onEnterPress={getSdk().systemManager.application.exit}
                onMouseUp={getSdk().systemManager.application.exit}
                size="small"
                dataSnUp={"@noOkModal_passThru"}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
                displayBlock={true}
              />
            </ModalSettings>
          </ExitModel>
        )}
        <GlobalStyle isFullScreen={isFullScreen} />
        <LayoutWrapperStyled
          isFullScreen={isFullScreen}
          onWheel={() => {
            this.onUpdateWheelState("active");
          }}
        >
          {!isFullScreen && isShowTooltip && <EpgTooltip />}
          {epgData.length !== 0 && (
            <PlayerWrapperStyled isFullScreen={isFullScreen}>
              {!isFullScreen && (
                <>
                  <LivePlayerShadeMeta direction={i18n.getDirection()}></LivePlayerShadeMeta>
                  <VideoMetaDataWrapperStyled direction={i18n.getDirection()}>
                    <VideoMetaData
                      videoData={currentVideoMetaData}
                      currentView={epgCurrentViewIndex}
                      isFocusOnEPG={this.props.applicationState.currentFocus === epgGridName}
                      refreshTime={this.state.refreshTime}
                      onBack={this.onBack}
                    />
                  </VideoMetaDataWrapperStyled>
                </>
              )}
              <VideoWrapperStyled direction={i18n.getDirection()}>
                {!isFullScreen && <LivePlayerShade direction={i18n.getDirection()}></LivePlayerShade>}
                <Wrapper direction={i18n.getDirection()} isFullScreen={isFullScreen}>
                  {currentVideoMetaData && !isFullScreen && !currentVideoMetaData.isUserSubscribedToChannel ? (
                    <PlayerPlaceholder
                      channelImage={
                        this.isValidUrl(currentVideoMetaData.eventPosterImage)
                          ? currentVideoMetaData.eventPosterImage
                          : this.appFlow !== RTL
                          ? DefaultChannelImage
                          : DefaultChannelImageLeft
                      }
                      isUpComingLinear={false}
                      isError={false}
                      inActiveSubscriptionName={
                        this.state.brandInfo?.btnName !== "activate"
                          ? this.state.brandInfo?.subscriptionDisplayName
                          : this.state.inActiveSubscriptionName
                      }
                      inActiveSubscriptionAction={this.state.inActiveSubscriptionAction}
                      actionLabel={this.state.brandInfo?.btnName}
                      actionPlanName={this.state.brandInfo?.planName}
                    />
                  ) : currentVideoMetaData && !isFullScreen && currentVideoMetaData.isThisDeviceSupported ? (
                    <PlayerPlaceholder
                      channelImage={
                        this.isValidUrl(currentVideoMetaData.eventPosterImage)
                          ? currentVideoMetaData.eventPosterImage
                          : this.appFlow !== RTL
                          ? DefaultChannelImage
                          : DefaultChannelImageLeft
                      }
                      isUpComingLinear={false}
                      deviceNotSupported={true}
                      isError={false}
                    />
                  ) : isError ? (
                    <PlayerPlaceholder
                      channelImage={
                        this.isValidUrl(currentVideoMetaData.eventPosterImage)
                          ? currentVideoMetaData.eventPosterImage
                          : this.appFlow !== RTL
                          ? DefaultChannelImage
                          : DefaultChannelImageLeft
                      }
                      isUpComingLinear={false}
                      isError={isError}
                      errorHeading={errorHeading}
                      errorMessage={errorMessage}
                      inActiveSubscriptionName={this.state.inActiveSubscriptionName}
                    />
                  ) : (
                    videoData &&
                    (!isUpComingLinear ? (
                      <LivePlayer
                        videoData={videoData}
                        onChange={this.onChange}
                        isFullScreen={isFullScreen}
                        autoplay={this.defaultChannelAutoPlay}
                        playFromStart={this.state.playFromStart}
                        playFromResume={this.state.playFromResume}
                        currentCol={this.indexes.colIndex}
                        currentRow={this.indexes.rowIndex}
                        currentCat={this.indexes.categoryIndex}
                        actions={this.props}
                        channelImage={currentVideoMetaData ? currentVideoMetaData.eventPosterImage : null}
                        setFocus={this.props.setFocus}
                        isEpgRefresh={isGridLoading}
                        wheelState={wheelState}
                        showQRCodeModal={showQRCodeModal}
                        toggleQRCodeModal={this.toggleQRCodeModal}
                      />
                    ) : (
                      <PlayerPlaceholder
                        channelImage={
                          this.isValidUrl(currentVideoMetaData.eventPosterImage)
                            ? currentVideoMetaData.eventPosterImage
                            : this.appFlow !== RTL
                            ? DefaultChannelImage
                            : DefaultChannelImageLeft
                        }
                        isError={false}
                        isUpComingLinear={isUpComingLinear}
                        inActiveSubscriptionName={this.state.inActiveSubscriptionName}
                      />
                    ))
                  )}
                </Wrapper>
              </VideoWrapperStyled>
            </PlayerWrapperStyled>
          )}
          {
            <EPGWrapperStyled>
              {epgData.length !== 0 && (
                <CategoriesWrapperHeadingStyled>
                  <TimeTextStyled direction={i18n.getDirection()}>
                    {i18n.get("pages.livePage.categories.header")}
                  </TimeTextStyled>
                </CategoriesWrapperHeadingStyled>
              )}
              {(epgData.length !== 0 || categories.length !== 0) && (
                <CategoriesWrapperStyled direction={i18n.getDirection()}>
                  <EpgCategories
                    items={categories}
                    onClick={this.onClickEpgCategory.bind(this)}
                    actionState={this.props}
                    onUpdateWheelState={this.onUpdateWheelState}
                    onChange={this.onChange}
                  />
                </CategoriesWrapperStyled>
              )}
              {isGridLoading ? (
                <GridLoadingWrapper>
                  <Loading opacity="0" />
                </GridLoadingWrapper>
              ) : epgData.length !== 0 ? (
                <EpgViews direction={i18n.getDirection()}>
                  {this.epgViews[epgCurrentViewIndex] === EPG_VIEWS.static ? (
                    <StaticEpgView
                      data={epgData}
                      currentDate={getCurrentDate()}
                      currentCategory={currentCategory}
                      onChange={this.onChange}
                      currentView={this.state.epgCurrentViewIndex}
                      changeViewRowIndex={this.changeViewRowIndex}
                      backToCetaogryColIndex={this.indexes.colIndex}
                      isFullScreen={this.state.isFullScreen}
                      visibleRows={this.visibleRows}
                      visibleCat={this.visibleCat}
                      changeView={this.changeView}
                      currentRowIndex={this.currentRowIndex}
                      categoryIndex={this.categoryIndex}
                      wheelState={this.state.isWheelFromSystem || this.state.wheelState === ACTIVE ? ACTIVE : IDLE}
                      actions={this.props}
                      onUpdateWheelState={this.onUpdateWheelState}
                      currentVideoMetaData={currentVideoMetaData}
                      onClickEpgSlots={this.onClickEpgSlots.bind(this)}
                    />
                  ) : (
                    <DynamicEpgView
                      data={epgData}
                      currentDate={getCurrentDate()}
                      epgStartDate={this.epgStartTime}
                      onChange={this.onChange}
                      currentView={this.state.epgCurrentViewIndex}
                      changeViewRowIndex={this.changeViewRowIndex}
                      isFullScreen={this.state.isFullScreen}
                      leftOffset={this.leftOffset}
                      rightOffset={this.rightOffset}
                      visibleRows={this.visibleRows}
                      visibleCat={this.visibleCat}
                      currentLiveIndex={this.currentLiveIndex}
                      currentCol={this.indexes.colIndex}
                      currentRow={this.indexes.rowIndex}
                      currentCat={this.indexes.categoryIndex}
                      currentRowIndex={this.currentRowIndex}
                      categoryIndex={this.categoryIndex}
                      wheelState={this.state.isWheelFromSystem || this.state.wheelState === ACTIVE ? ACTIVE : IDLE}
                      currentVideoMetaData={currentVideoMetaData}
                      actions={this.props}
                      onUpdateWheelState={this.onUpdateWheelState}
                      onClickEpgSlots={this.onClickEpgSlots.bind(this)}
                    />
                  )}
                </EpgViews>
              ) : (
                <LayoutEmptyStyled>
                  <strong>
                    <Text text={i18n.get("pages.livePage.noData.emptyDataMsg")} />
                  </strong>
                  <Text text={i18n.get("pages.livePage.noData.emptyDataSubMsg")} />
                </LayoutEmptyStyled>
              )}
            </EPGWrapperStyled>
          }
        </LayoutWrapperStyled>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(Live));
Component.defaultFocusPath = epgGridName;
export default Component;
